import { FunctionComponent, memo } from "react";
import { EllipsisMenu } from "@edgetier/client-components";

import AddRoleAction from "./add-role-action";
import RemoveRoleAction from "./remove-role-action";
import RoleForm from "../role-form";

import { IProps } from "./role-actions-menu.types";
import "./role-actions-menu.scss";

/**
 * A dropdown menu to edit or remove a role
 * @param props.role        Role selected to edit or remove
 */
const RoleActionsMenu: FunctionComponent<IProps> = ({ role }) => (
    <div className="role-actions-menu">
        <EllipsisMenu placement="bottom-end" overflowContainer>
            <AddRoleAction actionLabel="Edit role">
                {({ closeModal }) => <RoleForm toggleAction={closeModal} role={role} />}
            </AddRoleAction>
            <RemoveRoleAction actionLabel="Delete role" role={role}>
                <div className="role-action__remove">
                    <p>Are you sure you want remove the role &ldquo;{role.role}&rdquo;?</p>
                </div>
            </RemoveRoleAction>
        </EllipsisMenu>
    </div>
);

export default memo(RoleActionsMenu);
